export const diccionarioVista = {
  tituloListado: 'Administración de perfiles',
  tituloTabla: 'Perfiles ingresados',
  nombrePrincipal: 'Perfil',
  nombrePrincipalMayuscula: 'PERFIL',
  primerNombrePrincipal: 'perfil'
};
